export default {
  menu: {
    home: 'home',
    fee: 'fee',
    myAccount: 'Account',
    feeDetail: 'Detail',
    workOrder: 'Work Order',
    serviceDesk: 'Service Desk',
    message: 'Message',
    allMessage: 'All Message',
    unreadMessage: 'Unread Message',
    readMessage: 'Read Message',
    manage: 'Business Message',
    resource: 'Resource Manage',
    staff: 'Staff Manage',
    staffSetting: 'Staff Setting',
    staffManage: 'staff Manage',
    roleSetting: 'role Setting',
    inspectJob: 'inspect Job',
    notice: 'Notice',
    noticeNews: 'Notice&News',
    detailNotice: 'Notice Detail',
    newFunction: 'New Function',
    userCenter: 'User Center',
    information: 'Information',
    authentication: 'Authentication',
    score: 'Membership Score',
    authenticationByPerson: 'authenticationByPerson',
    authenticationByCompany: 'authenticationByCompany',
    authenticationByGovernment: 'authenticationByGovernment',
    authenticationByOrganization: 'authenticationByOrganization',
    seeAuthentication: 'See Authentication',
    fastAuthentication: 'Fast Authentication',
    order: 'order',
    buyKey: 'buy Key',
    renew: 'Renew',
    levelUp: 'Level Up',
    popularize: 'Popularize',
    statistics: 'Statistics',
    bindRegister: 'Bind Register',
    suitui: 'SuiTui',
    microPromotion: 'Micro Promotion',
    businessPromotion: 'Business Promotion',
    batchGeneration: 'Batch Generation',
    areaSelect: 'Area Select',
    evaluation: 'Evaluation',
    bootPage: 'Boot Page',
    webScore: 'Web Score',
    contrast: 'Contrast',
    marketing: 'Marketing',
    websiteManage: 'Website Manage',
    experience: 'Experience',
    seeResult: 'See Result',
    popularizeResult: 'Popularize Result',
    business: 'Business',
    miniprogramResult: 'MiniProgram Result',
    marketingResult: 'Marketing Result',
    zhentuiResult: 'Zhentui Result',
    ideaLaunch: 'Idea Launch',
    auditMaterial: 'Audit Material',
    insertWebsite: 'Insert Website',
    businessEdit: 'Business Edit',
    articleList: 'Article List',
    imageList: 'Image List',
    rejectList: 'Reject List',
    businessHelper: 'Business Helper',
    autoPublishSettings: "Automatic Publishing Settings",
    enquiryManagement: 'Enquiry Management',
    xcxList: 'xcx List',
    xcxDetail: 'xcx Detail',
    xcxOpen: 'xcx Open',
    xcxSelectTemplate: 'xcx Select Template',
    ideaManage: 'Idea Manage',
    ideaGroupManage: 'IdeaGroup Manage',
    ideaEdit: 'idea Edit',
    monthly: 'monthly',
    keywordRanking: 'keyword Ranking',
    KeyWordsManagement: 'KeyWords Management',
    aiExtension: 'AI Extension',
    flowStatistics: 'flow Statistics',
    materialConfig: 'Material Config',
    textMaterialManange: 'TextMaterial Manange',
    imgMaterialManange: 'ImgMaterial Manange',
    introductionPage: 'Introduction Page',
    advertisingSet: 'Advertising Set',
    articlePromote: 'Article Promote',
    promotionRecord: 'Promotion Record',
    picktrueHouse: 'Picktrue House',
    siteInformationSetting: 'Site Information Setting',
    bindRegister1: 'bind Register1',
    userManage: 'User Manage',
    transformation: 'transformation',
    transformationIndex: 'transformation Index',
    goodNews: 'Good News',
    normalNews: 'Normal News',
    digitalMap: 'Digital Map',
    allianceNews: 'Alliance News',
    zhenkoubei: 'koubei Zhen',
    zkbInformationSetting: 'zkb Information Setting',
    zkbPublishResults: 'zkb Publish Results',
    zkbReason: 'zkb Reason',
    keyword: 'Keyword',
    promotionList: 'Promotion List',
    utilities: 'Practical Tool',
    utilitiesIndex:"Utilities All",
    utilitiesList: 'Tool List',
    drainage: "Popularize Drainage",
    promotionList: "Promotion List",
    keywordList: "Keyword List"
  },
  content: {
    main: 'this is content'
  }
}
